import React, { useState, useEffect, useRef} from 'react';
//import Recipe from './recipe';
import '../styles/blocks/segments.scss';
import placeholder_img from '../images/placeholder-image.png';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';

const Segments = () => {
  const [segments, setSegments] = useState([]);
  const [active_segment, setActiveSegment] = useState(null);

  useEffect(() => {
    const fetchMedia = async (mediaId) => {
      console.log("fetchMedia");
      const url = await axios.get(`/wp-json/wp/v2/media/${mediaId}`)
        .then(res => { 
          return res.data?.source_url; // or return the entire res.data if needed
        })
        .catch(err => {
          console.log("Error fetching media:", err);
          return null;
        });
      return url;
    };

    const fetchSegments = async () => {
      try {
        const res = await axios.get('/wp-json/wp/v2/segment');
        const data = res.data;
        const temp_segments = await Promise.all(
          data.map(async (segment) => {
            if (segment.featured_media) {
              const url = await fetchMedia(segment.featured_media);
              return { ...segment, featured_media_url: url };
            } else {
              return segment;
            }
          })
        );
        console.log('segments', temp_segments);
        setSegments(temp_segments);
        setActiveSegment(temp_segments[0]);
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchSegments();
  }, []);

  if(segments.length == 0){
    return (
      <div className="segments__wrapper segments__wrapper--loading"></div>
    )
  }


  return(
      <div className="segments__wrapper">
          <Hero segment={active_segment} />
          <Nav segments={segments} active_segment={active_segment} setActiveSegment={setActiveSegment}/>
          <Content segment={active_segment} />
      </div>
  )
}

const Content = ({segment}) =>{

  if(segment == null){
    return null
  }

  return (
    <div className='content' dangerouslySetInnerHTML={{ __html: segment ? segment.content.rendered : '' }}></div>
  )
}

const Hero = ({segment}) => {
  if(segment == null){
    return null
  }
  return (
      <header className="hero">
          <img src={(segment.featured_media_url) ? segment.featured_media_url : placeholder_img}/>
          <div className='text' >
              <h1>Segments</h1>
              <h2 dangerouslySetInnerHTML={{ __html: segment.title.rendered }}></h2>
          </div> 
      </header>
  )
}

const Nav = ({segments, active_segment, setActiveSegment}) => {
    const listRef = useRef(null);
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 768);
  
    const findMaxWidth = () => {
        let maxWidth = 0;
        const liElements = listRef.current.children;
        for (let i = 0; i < liElements.length; i++) {
            const liWidth = liElements[i].scrollWidth;
            maxWidth = Math.max(maxWidth, liWidth);
        }
        return maxWidth+10;
    };
  
    const setEqualWidth = () => {
        const screenWidth = window.scrollWidth;
        if (screenWidth < 1000) {
            const maxWidth = findMaxWidth();
            const liElements = listRef.current.children;
            for (let i = 0; i < liElements.length; i++) {
                liElements[i].style.width = `${maxWidth}px`;
            }
        }
    };
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
      window.addEventListener('resize', handleResize);
  
      if(segments.length !== 0){
        setEqualWidth();
        window.addEventListener("resize", setEqualWidth);
      }
  
      return () => {
          window.removeEventListener("resize", setEqualWidth);
      };
    }, [segments]);

  
    if(segments.length === 0 ){
      return( 
        <nav className="segments_nav" aria-description='Segments Navigation Bar'></nav>
       );
    }
  
    return (
      <nav className="segments_nav" aria-description='Segments Navigation Bar'>

        {!isMobile && (
          <ul id="segments" aria-label='List of Segments' ref={listRef}>
            {segments.map((segment) => (
              <li role='button' 
              onClick={() => setActiveSegment(segment)} 
              key={segment.id} 
              dangerouslySetInnerHTML={{__html:segment.title.rendered}}
              className={(active_segment.id === segment.id) ? 'active' : ''}
              ></li>
            ))} 
          </ul>
        )}
        {isMobile && (
            <Swiper
              ref={listRef}
              spaceBetween={10}
              slidesPerView={'auto'}
              scrollbar={{
                hide: true,
              }}
              modules={[Scrollbar]}
              loop={false}
              centeredSlides={false}
              slideToClickedSlide={true}
            >
              {segments.map((segment) => (
                <SwiperSlide 
                  key={segment.id} 
                  style={{ width: 'auto' }}
                  className={(active_segment === segment.id) ? 'active' : ''}
                >
                  <div
                    role="button"
                    onClick={() => handleCatClick(segment)}
                    dangerouslySetInnerHTML={{ __html: segment.title.rendered }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
  
      </nav>
    )
}

export default Segments;